import { TrucksLoader } from './TrucksLoader';

export const trucksLoader: { (token?: string): TrucksLoader } = (token) => new TrucksLoader(token);
